<template>
  <div>
    <vs-row vs-justify="center" class="mt60">
      <vs-col vs-xs="12"></vs-col>
      <vs-col
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-sm="6"
        vs-lg="4"
        vs-xs="12"
      >
        <vs-card class="cardx">
          <div slot="header">
            <h4>
              Login
            </h4>
              <img
                size="40px"
                style="
                  float: right;
                  margin-top: -33px;
                  height: 44px;"
                :src="require('@/assets/logo-black.png')"
              />
          </div>
          <vs-row>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Email" v-model="login.email" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input
                label="Password"
                type="password"
                @keyup.enter="btnLoginClick"
                v-model="login.password"
              />
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-button @click="btnLoginClick">Login</vs-button>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="flink">
              <router-link to="/forgot-password">Forgot Password?</router-link>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>
    <div class="text-center">
      <small>Powered By - saaslabs.in</small>
    </div>
  </div>
</template>

<script>
import api from "../rest.js";
import { API } from "../common/constants";

export default {
  name: "Login",
  components: {},
  data() {
    return {
      login: {
        email: "",
        password: "",
        isAdmin: true
      },
    };
  },
  methods: {
    imgClick() {
      return this.$router.push("/");
    },
    btnLoginClick() {
      this.$vs.loading();
      api
        .post(API.LOGIN, this.$data.login)
        .then((r) => {
          this.$vs.loading.close();
          if (r.data.status) {
            this.$ls.set("user", JSON.stringify(r.data.data));
            this.$vs.notify({
              text: "Welcome " + r.data.data.name,
              color: "success",
              position: "top-right",
            });
            this.$store.state.isSidebarActive = true;
            this.$router.push("/home");
          } else {
            this.$vs.notify({
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: err.response.data.message,
            color: "danger",
            position: "top-right",
          });
        });
    },
  },
};
</script>
<style scoped>
.mt60 {
  margin-top: 60px;
  padding: 30px;
}
.flink {
  text-align: right;
  padding-top: 12px;
}
</style>
